/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useContext, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { FontAwesomeIcon, Radio, MessageError } from '@vr/lib';
import Button from '../elements/Button';
import MapaContext from '../context/Mapa';
import If from './If';

const Container = styled.div`
  .btn-select-product {
    background: transparent;
    color: #fff;
    border: 2px solid #fff;
    display: flex;
    width: 100%;
    padding: 14px 16px;
    border-radius: 4px;
    text-align: left;
    cursor: pointer;
    outline: 0;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    i {
      font-size: 18px;
    }
    .description-product {
      display: flex;
      align-items: center;
      img {
        margin-right: 5px;
      }
    }
  }
  .product-icon {
    max-width: 20px;
  }
  a.back-button {
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    display: flex;
    align-items: center;
    i {
      font-size: 20px;
      margin-right: 18px;
    }
  }
  .container-products {
    display: flex;
    flex-direction: column;
    height: calc(${({ height }) => height} - 50px);
    @media (max-width: ${({ theme }) => theme.devices.mobile}) {
      height: auto;
    }
  }
  ul {
    list-style: none;
    margin: 30px 0;
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow: auto;
    @media (max-width: ${({ theme }) => theme.devices.mobile}) {
      max-height: 50vh;
    }
    ::-webkit-scrollbar {
      width: 7px;
      height: 7px;
    }
    ::-webkit-scrollbar-button {
      width: 0px;
      height: 0px;
    }
    ::-webkit-scrollbar-thumb {
      background: #fff;
      border: 0px none ${({ theme }) => theme.colors.white};
      border-radius: 50px;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #fff;
    }
    ::-webkit-scrollbar-thumb:active {
      background: #fff;
    }
    ::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.2);
      border: 17px none ${({ theme }) => theme.colors.white};
      border-radius: 50px;
    }
    ::-webkit-scrollbar-track:hover {
      background: rgba(255, 255, 255, 0.2);
    }
    ::-webkit-scrollbar-track:active {
      background: #cccccc;
    }
    ::-webkit-scrollbar-corner {
      background: transparent;
    }
    li {
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .btn-apply-filters {
    margin-top: auto;
  }
`;

const RadioButton = styled(Radio)`
  > span {
    flex-shrink: 1;
    border-color: #fff !important;
  }
  color: rgba(255, 255, 255, 0.5);

  > div {
    display: flex;
    align-items: center;

    font-weight: 500;

    img {
      margin-right: 0.8125rem;
    }
  }

  &:hover {
    > span {
      border-color: ${({ theme }) => theme.colors.institucional} !important;
    }
  }
  ${({ checked }) =>
    checked &&
    css`
      color: #fff;
      > span {
        background-color: #fff;
        border-color: ${({ theme }) => theme.colors.institucional} !important;
      }
    `}
`;

function SelectProducts({
  value,
  products,
  onEdit,
  onSelect,
  messageError,
  renderOption,
  height,
  companyName,
}) {
  const { setFullBox } = useContext(MapaContext);
  const [opened, setOpened] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({});

  const toggleBox = useCallback(
    status => {
      setFullBox(status);
      setOpened(status);
      onEdit();
    },
    [onEdit, setFullBox],
  );

  const handleChooseProduct = useCallback(() => {
    toggleBox(true);
  }, [toggleBox]);

  const handleGoBack = useCallback(
    e => {
      e.preventDefault();
      toggleBox(false);
    },
    [toggleBox],
  );

  const handleSelectProduct = useCallback(
    product => {
      if (onSelect) {
        onSelect(product.code);
      }
    },
    [onSelect],
  );

  useEffect(() => {
    const product = products.find(item => item.code === value);
    setSelectedProduct(product || {});
  }, [value, products]);

  const renderContentButton = useCallback(() => {
    if (selectedProduct.code) {
      return (
        <div className="description-product">
          <img
            src={selectedProduct.image}
            alt={selectedProduct.name}
            className="product-icon"
          />
          {companyName && `${companyName} `}
          {selectedProduct.name}
        </div>
      );
    }

    return <>Selecione um cartão {companyName}...</>;
  }, [selectedProduct, companyName]);

  const renderContentOption = useCallback(
    product => {
      if (renderOption) {
        return renderOption(product);
      }

      return (
        <>
          <img
            src={product.image}
            alt={product.name}
            className="product-icon"
          />{' '}
          {companyName && `${companyName} `}
          {product.name}
        </>
      );
    },
    [renderOption, companyName],
  );

  return (
    <Container height={height}>
      <If test={!opened}>
        <div style={{ marginBottom: 20 }}>
          <button
            className="btn-select-product"
            type="button"
            onClick={handleChooseProduct}
          >
            {renderContentButton()}
            <FontAwesomeIcon icon="angle-right" />
          </button>
          {messageError && <MessageError>{messageError}</MessageError>}
        </div>
      </If>
      <If test={opened}>
        <div className="container-products">
          <a href="#" onClick={handleGoBack} className="back-button">
            <FontAwesomeIcon icon={['far', 'angle-left']} />
            Selecione os cartões que deseja
          </a>
          <ul>
            {products.map(product => (
              <li key={`produto-${product.code}`}>
                <RadioButton
                  onChange={() => handleSelectProduct(product)}
                  checked={product.code === selectedProduct.code}
                >
                  {renderContentOption(product)}
                </RadioButton>
              </li>
            ))}
          </ul>
          <Button
            type="button"
            className="btn-apply-filters"
            onClick={handleGoBack}
          >
            Aplicar filtros
          </Button>
        </div>
      </If>
      <input type="hidden" name="produto" id="produto" value={value} />
    </Container>
  );
}

SelectProducts.propTypes = {
  value: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.any).isRequired,
  onEdit: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  messageError: PropTypes.string,
  renderOption: PropTypes.func,
  height: PropTypes.string,
  companyName: PropTypes.string,
};

SelectProducts.defaultProps = {
  value: '',
  messageError: null,
  renderOption: null,
  height: 'auto',
  companyName: '',
};

export default SelectProducts;
